
import React, { useEffect, useState, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import config from '../../config';
import { useApi } from '../../ApiContext';
import PopupService from '../PopupService';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiFetch } from '../utils/ApiFetch';

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const DisplayEmailNotices = () => {
  const username = sessionStorage.getItem("username");
  const mrToken = localStorage.getItem("mr_token");
  const { callApi, setIsApiLoading } = useApi();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);
  const [searchTerm, setSearchTerm] = useState('');  
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState('emailDate');
  const [sortOrder, setSortOrder] = useState('desc');
  const searchInputRef = useRef();
  const [clients, setClients] = useState([]); 
  const [selectedClientId, setSelectedClientId] = useState('');
  const [expandedText, setExpandedText] = useState({});
  const [selectedAction, setSelectedAction] = useState({});
  const [showWorkEmail, setShowWorkEmail] = useState(false);
  const [mrNumbers, setMrNumbers] = useState("");
  const [mrSuggestions, setMrSuggestions] = useState([]);
  const [comments, setComments] = useState("");
  const [status, setStatus] = useState("");
  const [resolution, setResolution] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedMrList, setSelectedMrList] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedMongoId, setSelectedMongoId] = useState(null); 
  const [selectedNoticeTaskId, setSelectedNoticeTaskId] = useState('');
  const [isChangeStatusMode, setIsChangeStatusMode] = useState(false);
  const [showMoveNoticeForm, setShowMoveNoticeForm] = useState(false);
  const [moveToClientId, setMoveToClientId] = useState('');
  const moveTaskDivRef = useRef(null);
  const workOnEmailDivRef = useRef(null);
  const navigate = useNavigate();
  

  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get('page'), 10);
    let restoredPage = page;
    let restoredClientId = selectedClientId;

    if (location.state?.selectedClientId) {
      setSelectedClientId(location.state.selectedClientId);
      restoredClientId = location.state.selectedClientId;
    }
    if (pageParam && pageParam > 0) {
      setPage(pageParam);
      restoredPage = pageParam;
    }

    // Only fetch after both are set
    setTimeout(() => {
      fetchData({ page: restoredPage, clientId: restoredClientId });
    }, 0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchData({ page, pageSize, clientId: selectedClientId });
    // eslint-disable-next-line
  }, [page, pageSize, selectedClientId]);
  
  const toggleExpandText = (rowIdx) => {
    setExpandedText(prev => ({
      ...prev,
      [rowIdx]: !prev[rowIdx]
    }));
  };
  
  const toggleRowExpand = (idx) => {
    setExpandedRows(prev => ({
      ...prev,
      [idx]: !prev[idx]
    }));
  };
  
  useEffect(() => {
    const fetchClients = async () => {
  	setLoading(true);
  		await callApi(async () => {
  			setIsApiLoading(true);
          try {
            const response = await apiFetch(`${config.API_BASE_URL}/activeclients`,
              {headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`}},
            );
            if (response.ok) {
              const data = await response.json();
              setClients(Array.isArray(data.data.ACTIVE_CLIENTS) ? data.data.ACTIVE_CLIENTS : []);
            }
          } catch (err) {
            setClients([]);
          }finally {
    			setLoading(false);
    			setIsApiLoading(false);
    		}
  	  	});
    };
    fetchClients();
  }, []);

  
  const handleClientChange = (e) => {
    const clientId = e.target.value;
    setSelectedClientId(clientId);
    setPage(1);
    fetchData({ page: 1, clientId });
  };
  
  const fetchData = async (params = {}) => {
    setLoading(true);
    const payload = {
      pageNo: params.page || page,
      pageSize: params.pageSize || pageSize,
      searchTerm: params.searchTerm !== undefined ? params.searchTerm : searchTerm,
      sortField: params.sortField || sortField,
      sortOrder: params.sortOrder || sortOrder,
	  clientId: params.clientId !== undefined ? params.clientId : selectedClientId, 
    };
	setLoading(true);
	    await callApi(async () => {
	      setIsApiLoading(true);
	    try {
	      const res = await apiFetch(`${config.API_BASE_URL}/emailNotices/loadEmailNoticeTask`, {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'X-Username': username,
	          'Authorization': `Bearer ${mrToken}`,
	        },
	        body: JSON.stringify(payload),
	      });
	      const json = await res.json();
	      setData(json.data?.SEARCH_LIST || []);
	      setTotal(json.data?.total || 0);
	    } catch (e) {
	      setData([]);
	      setTotal(0);
	    } finally {
  	        setLoading(false);
  	        setIsApiLoading(false);
  	      }
  	    });
    
  };

  useEffect(() => {
    fetchData({ page: 1 });
    // eslint-disable-next-line
  }, [pageSize]);

  const handleSearch = () => {
    setPage(1);
    fetchData({ page: 1, searchTerm });
  };

  const handleClear = () => {
    setSearchTerm('');
    setPage(1);
    fetchData({ page: 1, searchTerm: '' });
    searchInputRef.current.focus();
  };

  const handleSort = (field) => {
    let order = 'asc';
    if (sortField === field && sortOrder === 'asc') order = 'desc';
    setSortField(field);
    setSortOrder(order);
    fetchData({ sortField: field, sortOrder: order });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchData({ page: newPage });
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setPage(1);
    fetchData({ page: 1, pageSize: Number(e.target.value) });
  };

  const handlePageJump = (e) => {
    e.preventDefault();
    const val = Number(e.target.pageJump.value);
    if (val > 0 && val <= Math.ceil(total / pageSize)) {
      setPage(val);
      fetchData({ page: val });
    }
  };

  const totalPages = Math.ceil(total / pageSize);
  

	const handleMrInputChange = async (e) => {
	  const value = e.target.value;
	  setMrNumbers(value);

	  if (value.length > 6) {
	    const response = await fetch(
	      `${config.API_BASE_URL}/mrnumbers?searchString=${encodeURIComponent(value)}`,
	      {
	        headers: {
	          "Content-Type": "application/json",
	          "X-Username": username,
	          Authorization: `Bearer ${mrToken}`,
	        },
	      }
	    );
	    const data = await response.json();
	    const suggestions = Array.isArray(data.data)
	      ? data.data.filter(item => item.mrNumber && item.alertTitle)
	      : [];
	    setMrSuggestions(suggestions);

	    // If user selects from dropdown, add to selectedMrList
	    const selected = suggestions.find(item => item.mrNumber === value);
	    if (selected && !selectedMrList.some(mr => mr.mrNumber === selected.mrNumber)) {
	      setSelectedMrList(prev => [...prev, selected]);
	      setMrNumbers(""); // clear input after selection
	    }
	  } else {
	    setMrSuggestions([]);
	  }
	};
	
	const handleRemoveMr = (mrNumber) => {
	  setSelectedMrList(prev => prev.filter(item => item.mrNumber !== mrNumber));
	};



	const handleActionChange = (e, mongoId, noticeTaskId, selectedValue) => {
	  setSelectedOptions(prev => ({
	    ...prev,
	    [mongoId]: selectedValue
	  }));
	  setSelectedMongoId(mongoId);
	  setSelectedNoticeTaskId(noticeTaskId);

	  setShowMoveNoticeForm(false);
	  setMoveToClientId('');
		
	  if (selectedValue === "move") {
	    setShowMoveNoticeForm(true);
	    setTimeout(() => {
	      moveTaskDivRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
	    }, 100); // Delay to ensure the div is rendered
	  }else {
	     setShowMoveNoticeForm(false);
	   }
	   
	  if (selectedValue === "createAlert") {
	    navigate('/alerts/createalert', { state: { noticeTaskId, fromEmailNotices: true, emailNoticesPage: page, selectedClientId  } });
	    return;
	  }

	  setShowWorkEmail(selectedValue === "work" || selectedValue === "changeStatus");
	  setIsChangeStatusMode(selectedValue === "changeStatus");
	  if (selectedValue === "work" || selectedValue === "changeStatus") {
		setTimeout(() => {
	      workOnEmailDivRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
	    }, 100);
	    setMrNumbers("");
	    setMrSuggestions([]);
	    setSelectedMrList([]);
	    setComments("");
	    setResolution("");
	    setStatus("");
	  }
	};

	const handleWorkOnEmail = async () => {
	  if (!selectedMongoId) return;

	  // Status required validation
	  if (!status) {
	    PopupService.getInstance().showMessage('Status is required, please select status and then continue', false);
	    // Highlight status dropdown
	    const statusDropdown = document.getElementById('act_status');
	    if (statusDropdown) {
	      statusDropdown.style.border = '2px solid red';
	      setTimeout(() => {
	        statusDropdown.style.border = '';
	      }, 2000);
	    }
	    return;
	  }

	  // If only status is selected (comments, resolution, mrNumbers are empty)
	  if (
	    status &&
	    !comments &&
	    !resolution &&
	    (!selectedMrList || selectedMrList.length === 0)
	  ) {
	    const confirmed = await PopupService.getInstance().showConfirm(
	      'You have only selected to change status, do you want to continue?'
	    );
	    if (!confirmed) return;
	  }

	  const payload = {
	    comments,
	    status,
	    resolution,
	    mrNumbers: Array.isArray(selectedMrList) ? selectedMrList.map(item => item.mrNumber) : [],
	    mongoId: selectedMongoId,
	    username: username
	  };
	  setLoading(true);
	  	await callApi(async () => {
	  	setIsApiLoading(true);
	  	try {
		  const response = await apiFetch(`${config.API_BASE_URL}/emailNotices/addWorkToEmail`, {
		    method: "POST",
		    headers: {
		      "Content-Type": "application/json",
		      "X-Username": username,
		      Authorization: `Bearer ${mrToken}`,
		    },
		    body: JSON.stringify(payload),
		  });
	
		  if (response.status == 200) {
		    setSelectedMrList([]);
		    setComments("");
		    setStatus("");
		    setResolution("");
		    setShowWorkEmail(false);
		    PopupService.getInstance().showMessage('Email record updated successfully', true);
		    fetchData({ page });
		  } else {
		    PopupService.getInstance().showMessage('Error while updating email record!', false);
		  }
	     }finally {
			 setLoading(false);
    	        setIsApiLoading(false);
    	      }
		 });
	};



	const handleNoticeAttachmentDownLoad = async (mongoId, filename) => {
	  
	  if (!username || !mrToken) {
	    alert("You are not logged in.hello");
	    return;
	  }
	  try {
	    const response = await apiFetch(`${config.API_BASE_URL}/emailNotices/downloadNoticeAttachment`, {
	      method: "POST",
	      headers: {
	        "Content-Type": "application/json",
	        "X-Username": username,
	        "Authorization": `Bearer ${mrToken}`,
	      },
	      body: JSON.stringify({ mongoId }),
	    });
	    if (response.status === 401) {
	      alert("Unauthorized. Please log in again.");
	      // Optionally redirect to login
	      return;
	    }
	    if (!response.ok) {
	      alert("Failed to download attachment.");
	      return;
	    }
	    const blob = await response.blob();
	    // Get filename from Content-Disposition header if available
	    const contentDisposition = response.headers.get("Content-Disposition");
	    let downloadFilename = filename;
	    if (contentDisposition) {
	      const match = contentDisposition.match(/filename="(.+)"/);
	      if (match) downloadFilename = match[1];
	    }
	    // Download the file
	    const url = window.URL.createObjectURL(blob);
	    const a = document.createElement("a");
	    a.href = url;
	    a.download = downloadFilename;
	    document.body.appendChild(a);
	    a.click();
	    a.remove();
	    window.URL.revokeObjectURL(url);
	  } catch (err) {
	    alert("Error downloading attachment.");
	  }
	};


	const handleDiscardNoticeTask = async (mongoId) => {
		setLoading(true);
		await callApi(async () => {
		setIsApiLoading(true);
		  try {
		    const response = await apiFetch(`${config.API_BASE_URL}/emailNotices/discardEmailNotice`, {
		      method: 'POST',
		      headers: {
		        "Content-Type": "application/json",
		        "X-Username": username,
		        "Authorization": `Bearer ${mrToken}`,
		      },
		      body: JSON.stringify({ mongoId: mongoId, username: username, status: 'DISCARD' }),
		    });
		    const data = await response.json();
		    if (response.status === 200 && data.statusCode === 200) {
		      PopupService.getInstance().showMessage("Notice discarded successfully.", true);
		      fetchData({ page }); // reloads the table with the current page
		    } else {
		      PopupService.getInstance().showMessage("Failed to discard notice.", false);
		    }
		  } catch (error) {
		    PopupService.getInstance().showMessage("Error discarding notice.", false);
		  }	finally {
  	        setLoading(false);
  	        setIsApiLoading(false);
  	      }
  	    });
	};
	

	const handleMoveEmailNotice = async () => {
	  if (!moveToClientId || !selectedNoticeTaskId) {
	    PopupService.getInstance().showMessage("Select a client to move the notice.", true);
	    return;
	  }
	  setLoading(true);
	  
	  await callApi(async () => {
	  setIsApiLoading(true);
	  try {
	    const response = await apiFetch(`${config.API_BASE_URL}/emailNotices/moveNoticeTask`, {
	      method: "POST",
	      headers: {
	        "Content-Type": "application/json",
	        "X-Username": username,
	        Authorization: `Bearer ${mrToken}`,
	      },
	      body: JSON.stringify({
	        noticeTaskId: selectedNoticeTaskId,
	        selectedClientId: moveToClientId,
	      }),
	    });
	    const data = await response.json();
	    if (response.status === 200) {
	      PopupService.getInstance().showMessage("Email Notice moved successfully.", true);
	      setShowMoveNoticeForm(false);
	      fetchData();
	    } else {
	      PopupService.getInstance().showMessage("Move failed: " + (data.message || ""), false);
	    }
	  } catch (e) {
	    PopupService.getInstance().showMessage("Move failed.", true);
	  } finally {
	    setLoading(false);
		setIsApiLoading(false);
	    setMoveToClientId('');
	    setSelectedNoticeTaskId('');
	    setSelectedMongoId(null);
	    setSelectedOptions("");
		
	  }
	  });
	};


  return (
    <>
      <Header />
      <div className="container-fluid text-secondary">
        <br />
		<br/>
		<br/>
		<br/>
        <div className="card">
          <div className="card-header">View Email Notices</div>
          <div className="card-body custom-card-bg">
		 
			<>
			{showMoveNoticeForm && (

			<div className="card mb-3" id="move_task_div" ref={moveTaskDivRef}>
			  <div className="card-header text-info fw-bold">
			    {`Choose a client from the list to transfer this email notice ${selectedNoticeTaskId} to:`}
			  </div>

			    <div className="card-body col-md-3">
			      <div className="mb-3">
			        <select
			          className="form-select "
			          value={moveToClientId}
			          onChange={e => setMoveToClientId(e.target.value)}
			        >
			          <option value="">Select Client</option>
			          {clients
			            .filter(client => client.clientId !== "00000")
			            .map((client, idx) => (
			              <option key={idx} value={client.clientId || client.id}>
			                {client.clientName || client.name}
			              </option>
			            ))}
			        </select>
			      </div>
			      <div className="d-flex justify-content-left">
			        <button
			          className="btn btn-secondary btn-sm me-2"
			          onClick={() => {
			            setShowMoveNoticeForm(false);
			            setSelectedOptions("");
			            setSelectedMongoId(null);
			            setSelectedNoticeTaskId('');
			            setMoveToClientId('');
			          }}
			        >
			          Cancel
			        </button>
			        <button
			          className="btn btn-primary btn-sm"
					  onClick={async () => {
					    if (!moveToClientId) {
					      PopupService.getInstance().showMessage('Please select a client to move this alert to', false);
					      return;
					    }
					    const confirmed = await PopupService.getInstance().showConfirm(
					      `Are you sure you want to move this email notice to Client: ${moveToClientId}?`
					    );
					    if (confirmed) {
					      handleMoveEmailNotice();
					    }
					  }}
			          disabled={!moveToClientId}
			        >
			          Move
			        </button>
			      </div>
			    </div>
			  </div>
			)}
			{showWorkEmail && selectedNoticeTaskId && (

				<div className="card" id="work_email" style={{ display: showWorkEmail ? "block" : "none" }} ref={workOnEmailDivRef}>
				  <div className='card-header'>
				    {isChangeStatusMode
				      ? `Change Status - ${selectedNoticeTaskId}`
				      : `Work on Email - ${selectedNoticeTaskId}`}
				  </div>
				  <div className="card-body">
				    <div className="row">
				      <div className="form-group col-md-2" id="mr_number_div">
				        <label htmlFor="mr_number" className="text-info fw-bold" id="mrn_label2">Link MR Number</label>
				        <input
				          type="text"
				          className="form-control basicAutoComplete"
				          id="mr_number"
				          data-noresults-text="No MR Number Found"
				          autoComplete="off"
				          placeholder="Enter MR Number here to link"
				          value={mrNumbers}
				          onChange={handleMrInputChange}
				          list="mr-autocomplete"
				          disabled={isChangeStatusMode}
				        />
				        <datalist id="mr-autocomplete">
				          {mrSuggestions.map((item, idx) => (
				            <option key={idx} value={item.mrNumber}>
				              {item.alertTitle}
				            </option>
				          ))}
				        </datalist>
				        <div>
				          <small className="text-danger" style={{ fontStyle: "italic" }}>
				            Multiple MR Numbers Can Be Linked.
				          </small>
				        </div>
				      </div>
				      <div className="form-group col-md-3">
				        <label className="text-info fw-bold">Enter Comments:</label>
				        <textarea
				          className="form-control"
				          id="comments"
				          name="comments"
				          rows="3"
				          placeholder="Enter Comments Here"
				          value={comments}
				          onChange={(e) => setComments(e.target.value)}
				          disabled={isChangeStatusMode}
				        ></textarea>
				      </div>
				      <div className="form-group col-md-2">
				        <label className="text-info fw-bold">Select Status:</label>
				        <select
				          className="form-select"
				          id="act_status"
				          value={status}
				          onChange={(e) => setStatus(e.target.value)}
				        >
				          <option value="">Select Status</option>
				          <option value="IN PROGRESS">IN PROGRESS</option>
				          <option value="COMPLETED">COMPLETED</option>
				          <option value="DISCARD">DISCARD</option>
				          <option value="NEW">NEW</option>
				          <option value="FOR REVIEW">FOR REVIEW</option>
				          <option value="PENDING">PENDING</option>
				          <option value="CLEANUP CLOSED">CLEANUP CLOSED</option>
				          <option value="CLEANUP REVIEW">CLEANUP REVIEW</option>
				        </select>
				      </div>
				      <div className="form-group col-md-3">
				        <label className="text-info fw-bold">Select Resolution:</label>
				        <select
				          className="form-select"
				          id="resolution_status"
				          value={resolution}
				          onChange={(e) => setResolution(e.target.value)}
				          disabled={isChangeStatusMode}
				        >
				          <option value="">Select Resolution</option>
				          <option value="New Alert Created">New Alert Created</option>
				          <option value="Duplicate of Existing Alert - New Client Info">Duplicate of Existing Alert - New Client Info</option>
				          <option value="Duplicate of Existing Alert - Duplicate Client Info">Duplicate of Existing Alert - Duplicate Client Info</option>
				          <option value="Update to Existing Alert- New Client Info">Update to Existing Alert- New Client Info</option>
				          <option value="Update to Existing Alert - Duplicate Client Info">Update to Existing Alert - Duplicate Client Info</option>
				          <option value="Contacted Client For Routing Info">Contacted Client For Routing Info</option>
				          <option value="Requested Support For Routing Info">Requested Support For Routing Info</option>
				          <option value="Alert Distributed">Alert Distributed</option>
				          <option value="Discarded Email">Discarded Email</option>
				          <option value="Legacy Clean-up - No Matches Found">Legacy Clean-up - No Matches Found</option>
				          <option value="Legacy Cleanup - New in Bin">Legacy Cleanup - New in Bin</option>
				          <option value="Legacy Cleanup - Already Distributed">Legacy Cleanup - Already Distributed</option>
				          <option value="Legacy Cleanup - New in Stage">Legacy Cleanup - New in Stage</option>
				          <option value="Legacy Cleanup - Not in Client System">Legacy Cleanup - Not in Client System</option>
				        </select>
				      </div>
				    </div>
				    <div id="selected_mrnumbers">
				      <ul>
				        {selectedMrList.map(item => (
				          <li key={item.mrNumber} id={item.mrNumber} className="d-flex align-items-center">
				            {item.alertTitle}
				            <button
				              type="button"
				              className="btn btn-link btn-sm text-danger ms-2"
				              onClick={() => handleRemoveMr(item.mrNumber)}
				              title="Remove MR Number from linking"
				              disabled={isChangeStatusMode}
				            >
				              <i className="fa fa-trash"></i>
				            </button>
				          </li>
				        ))}
				      </ul>
				    </div>
				    <div className="d-flex justify-content-center mt-3">
				      <button
				        className="btn btn-secondary btn-sm me-2"
				        onClick={() => {
				          setShowWorkEmail(false);
				          setSelectedOptions("");
				          setStatus("");
				          setResolution("");
				          setComments("");
				          setIsChangeStatusMode(false);
				        }}
				      >
				        Cancel
				      </button>
				      <button
				        className="btn btn-danger btn-sm"
				        onClick={handleWorkOnEmail}
				      >
				        {isChangeStatusMode ? "Change Status" : "Update Work for Email"}
				      </button>
				    </div>
				  </div>
				</div>

		)}
		{showWorkEmail && <br />}
		</>
		
			
		  <div className="card">
		   <div className='card-body'>			 
            <div className="mb-3 d-flex align-items-center">
              <form
                className="d-flex align-items-center"
                onSubmit={e => { e.preventDefault(); handleSearch(); }}
                style={{ marginRight: 10 }}
              >
                <input
                  ref={searchInputRef}
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
                  style={{ width: 250 }}
                />
                <button type="button" className="btn btn-link text-secondary" onClick={handleSearch}>
                  <i className='fa fa-search'></i>
                </button>
                {searchTerm && (
                  <button type="button" className="btn btn-link text-secondary" onClick={handleClear}>
                    <i className='fa fa-trash'></i>
                  </button>
                )}
              </form>
              <div>
                <label className="me-2">Page size:</label>
                <select value={pageSize} onChange={handlePageSizeChange} className="form-select d-inline-block" style={{ width: 80 }}>
                  {PAGE_SIZE_OPTIONS.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
				&nbsp;
              </div>
			  <label htmlFor="client_select" className="text-secondary fw-bold">&nbsp;Select Client&nbsp;&nbsp;</label>   
                  <div className="form-group col-md-3">                                                                        
                        <select
                          id="client_select"
                          className="form-select"
                          value={selectedClientId}
                          onChange={handleClientChange}
                        >
                         <option value="">Select Client</option>
						 <option value="00000">Default Client</option>
                          {clients.map((client, idx) => (
                            <option key={idx} value={client.clientId || client.id}>
                              {client.clientName || client.name}
                            </option>
                          ))}
                       </select> 
					   
  	             </div>
  		      </div>
            
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-striped ">
                <thead>
                  <tr>
				  <th></th>
				  <th>No.</th>
				  <th></th>
				  <th>Actions</th>
				  <th>Notice Id</th>
                    <th>
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('emailDate')}
                      >
                        Email Date{' '}
                        {sortField === 'emailDate' ? (sortOrder === 'asc' ? <i className='fa fa-sort-asc'></i> : <i className='fa fa-sort-desc'></i>) : <i className='fa fa-sort'></i>}
                      </span>
                    </th>
                    <th>
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('clientId')}
                      >
                        Client ID{' '}
                        {sortField === 'clientId' ? (sortOrder === 'asc' ?  <i className='fa fa-sort-asc'></i> : <i className='fa fa-sort-desc'></i>) : <i className='fa fa-sort'></i>}
                      </span>
                    </th>
					<th>Resolution</th>                    
                    <th>MR Numbers</th>
					<th>Subject</th>
					<th>Details</th>
                    <th>Status</th>
					<th>Attachments</th>
                  </tr>
                </thead>


				<tbody>
				  {data.length === 0 ? (
				    <tr>
				      <td colSpan="10" className="text-center text-muted">No records found.</td>
				    </tr>
				  ) : (
				    data.map((row, idx) => {
				      let rowClass = '';
				      if (row.status === 'New') rowClass = 'bg-info';
				      else if (row.status === 'COMPLETED') rowClass = 'table-success';
				      else if (row.status === 'DISCARD') rowClass = 'table-danger';
				      else if (row.status === 'FOR REVIEW') rowClass = 'table-warning';
					  else if (row.status === 'IN PROGRESS') rowClass = 'table-info';

				      return (
				        <React.Fragment key={idx}>
				          <tr className={rowClass}>
				            {/* Expand/Collapse workHistory icon */}
				            <td style={{ width: 30, textAlign: "center" }}>
				              {row.workHistory && row.workHistory.length > 0 ? (
				                <i
				                  className={`fa ${expandedRows[idx] ? "fa-minus-square" : "fa-plus-square"} text-secondary`}
				                  style={{ cursor: "pointer" }}
				                  onClick={() => toggleRowExpand(idx)}
				                  aria-label="Expand work history"
				                />
				              ) : null}
				            </td>
				            <td>{(page - 1) * pageSize + idx + 1}</td>
							<td>
							  <i className="fa fa-trash text-danger"  
							    style={{ cursor: 'pointer' }}              
							    
								onClick={async () => {
								 const confirmed = await PopupService.getInstance().showConfirm(
		                            'Do you want to discard this email notice?'
		                          );
		                          if (confirmed) {
		                            handleDiscardNoticeTask(row.mongoId);
		                          }
		                        }}
								
							    title="Discard Notice"
							  ></i>
							</td>
				            <td>
							<select
							  className="form-select form-select-sm"
							  style={{ width: 140 }}
							  value={selectedOptions[row.mongoId] || ""}
							  onChange={e => handleActionChange(e, row.mongoId, row.noticeTaskId, e.target.value)}
							>
							  <option value="">Select Action</option>
							  <option value="createAlert">Create Alert</option>
							  <option value="work">Work On Email</option>
							  <option value="changeStatus">Change Status</option>
							  {selectedClientId === "00000" && (
							    <option value="move">Move Notice</option>
							  )}
							</select>
							</td>
				            <td>{row.noticeTaskId}</td>
				            <td>{row.emailDate ? new Date(row.emailDate).toLocaleDateString() : ''}</td>
				            <td>{row.clientId}</td>
				            <td>{row.resolution}</td>
				            <td>{row.mrNumbers}</td>
				            <td>{row.subject}</td>
				            <td>
				              {row.notes && row.notes.length > 70 ? (
				                expandedText[idx] ? (
				                  <>
				                    <span
				                      className="badge bg-info"
				                      onClick={() => toggleExpandText(idx)}
				                      style={{ cursor: 'pointer' }}
				                    >
				                      <i className="fa fa-minus-square text-light"></i>&nbsp;Collapse
				                    </span>
									<br/>
				                    <span
				                      dangerouslySetInnerHTML={{ __html: row.notes }}
				                    />
									<br/>
				                    <span
				                      className="badge bg-info"
				                      onClick={() => toggleExpandText(idx)}
				                      style={{ cursor: 'pointer' }}
				                    >
				                      <i className="fa fa-minus-square text-light"></i>&nbsp;Collapse
				                    </span>
									
				                  </>
				                ) : (
				                  <>
				                    <span
				                      dangerouslySetInnerHTML={{
				                        __html: row.notes.slice(0, 70) + '...'
				                      }}
				                    />
									<br/>
				                    <span
				                      className="badge bg-info"
				                      onClick={() => toggleExpandText(idx)}
				                      style={{ cursor: 'pointer' }}
				                    >
				                      <i className="fa fa-plus-square text-light"></i>&nbsp;Expand
				                    </span>
				                  </>
				                )
				              ) : (
				                <span
				                  dangerouslySetInnerHTML={{ __html: row.notes || '' }}
				                />
				              )}
				            </td>
				            <td>{row.status}</td>
							<td>
							  {row.attachmentsInfo
							    ? row.attachmentsInfo.split(",").map((item, idx) => {
							        const [mongoId, filename] = item.split("~");
							        if (!mongoId || !filename) return null;
							        return (
							          <React.Fragment key={mongoId}>
							            <a
							              href="#"
							              onClick={e => {
							                e.preventDefault();
							                handleNoticeAttachmentDownLoad(mongoId, filename);
							              }}
							            >
							              {filename}
							            </a>
							            <br />
							          </React.Fragment>
							        );
							      })
							    : null}
							</td>
				          </tr>
				          {/* Expanded workHistory row */}
				          {expandedRows[idx] && row.workHistory && row.workHistory.length > 0 && (
				            <tr>

							<td colSpan={13} className="bg-light">
							  {row.workHistory.map((item, i) => (
							    <div className={i % 2 === 0 ? "alert alert-info" : "alert alert-warning"} key={i}>
							      
								  <strong>({i + 1}).Comment</strong>{' '}
							      <span dangerouslySetInnerHTML={{ __html: item.comment || '' }} /><br />
							      {item.comment_by && (
							        <>
							          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Comment By:</strong> {item.comment_by} <br />
							        </>
							      )}
							      {item.comment_date && (
							        <>
							          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Comment Date:</strong> {new Date(item.comment_date).toLocaleTimeString()} <br />
							        </>
							      )}
							    </div>
							  ))}
							</td>

				            </tr>
				          )}
				        </React.Fragment>
				      );
				    })
				  )}
				</tbody>


              </table>
            </div>
            {/* Pagination */}
            <div className="d-flex align-items-center justify-content-between mt-3">
			<nav>
			  <ul className="pagination mb-0">
			    {/* First Page */}
			    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
			      <button className="page-link text-secondary" onClick={() => handlePageChange(1)} disabled={page === 1}>
			        <i className="fa fa-angle-double-left"></i>
			      </button>
			    </li>
			    {/* Previous Page */}
			    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
			      <button className="page-link text-secondary" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
			        <i className="fa fa-angle-left"></i> Prev
			      </button>
			    </li>
			    {/* Page Numbers */}
			    {Array.from({ length: Math.min(10, totalPages) }, (_, i) => {
			      let pageNum = i + 1;
			      if (page > 6 && totalPages > 10) {
			        pageNum = page - 5 + i;
			        if (pageNum < 1) pageNum = i + 1;
			        if (pageNum > totalPages - 9) pageNum = totalPages - 9 + i;
			      }
			      if (pageNum > totalPages) return null;
			      return (
			        <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>

					<button
					  className={`page-link ${page === pageNum ? 'text-light' : 'text-secondary'}`}
					  onClick={() => handlePageChange(pageNum)}
					>
					  {pageNum}
					</button>

			        </li>
			      );
			    })}
			    {/* Next Page */}
			    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
			      <button className="page-link text-secondary" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
			        Next <i className="fa fa-angle-right"></i>
			      </button>
			    </li>
			    {/* Last Page */}
			    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
			      <button className="page-link text-secondary" onClick={() => handlePageChange(totalPages)} disabled={page === totalPages}>
			        <i className="fa fa-angle-double-right"></i>
			      </button>
			    </li>
			  </ul>
			</nav>
              <form className="d-flex align-items-center" onSubmit={handlePageJump}>
                <label className="me-2">Jump to page:</label>
                <input
                  type="number"
                  name="pageJump"
                  min="1"
                  max={totalPages}
                  className="form-control"
                  style={{ width: 80 }}
                  defaultValue={page}
                />
                <button type="submit" className="btn btn-secondary btn-sm ms-2">Go</button>
              </form>
              <div>
                <span className='text-secondary'>Page {page} of {totalPages} pages, total records {total}</span>
              </div>
            </div>
          </div>
		  </div>
		  </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DisplayEmailNotices;
